var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col mt-5"},[_c('div',{staticClass:"row",staticStyle:{"margin":"20px"}},[_c('input',{attrs:{"id":"date"}})])])
}]

export { render, staticRenderFns }